export default "__VITE_PUBLIC_ASSET__982ce647__"